import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	block: {
		width: '100%',
		display: 'flex',
		alignItems: 'start',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: theme.spacing.small,
		boxSizing: 'border-box',
		padding: theme.spacing.small,
		backgroundColor: theme.review.background.color,
		boxShadow: theme.review.elevation,
		borderRadius: theme.borderRadius.rounded,

		[getFromBreakpoint('md')]: {
			alignItems: 'center',
			flexDirection: 'row',
		},
	},
	info: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xsmall,
	},
	details: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: theme.spacing.tiny,
	},
	detailsText: {
		margin: 0,
	},
	starRating: {
		gap: theme.spacing.tiny,
	},
	buttons: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.small,
	},
}));
